module.exports = __webpack_public_path__ + "media/images/application/icons/icon-tag-11e139da9c1bcefa7dd1d71f44e260ab.svg";